module.exports = __webpack_public_path__ + "img/profile-no-img.99d6b3a5.png";